/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetProjectResponse } from '../models/get-project-response';
import { GetProjectsPaginResponseOfGetProjectForTableResponse } from '../models/get-projects-pagin-response-of-get-project-for-table-response';
import { PaginRequest } from '../models/pagin-request';
import { GetStageForTableResponse } from '../models/get-stage-for-table-response';
import { CreateProjectResponse } from '../models/create-project-response';
import { CreateProjectRequest } from '../models/create-project-request';
import { UpdateProjectRequest } from '../models/update-project-request';
@Injectable({
  providedIn: 'root',
})
class ProjectService extends __BaseService {
  static readonly ProjectGetAllPath = '/Project/GetAll';
  static readonly ProjectGetAllWithNestedPath = '/Project/GetAllWithNested';
  static readonly ProjectGetByIdPath = '/Project/GetById';
  static readonly ProjectGetByIdWithNestedPath = '/Project/GetByIdWithNested';
  static readonly ProjectGetAllForProjectTablePath = '/Project/GetAllForProjectTable';
  static readonly ProjectGetAllForProcessTablePath = '/Project/GetAllForProcessTable';
  static readonly ProjectCreatePath = '/Project/Create';
  static readonly ProjectCreateRangePath = '/Project/CreateRange';
  static readonly ProjectUpdatePath = '/Project/Update';
  static readonly ProjectDeletePath = '/Project/Delete';
  static readonly ProjectDeleteRangePath = '/Project/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ProjectGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetProjectResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Project/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetProjectResponse>>;
      })
    );
  }  ProjectGetAll(): __Observable<Array<GetProjectResponse>> {
    return this.ProjectGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetProjectResponse>)
    );
  }

  /**
   * @param showWithArchived undefined
   */
  ProjectGetAllWithNestedResponse(showWithArchived?: boolean): __Observable<__StrictHttpResponse<Array<GetProjectResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (showWithArchived != null) __params = __params.set('showWithArchived', showWithArchived.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Project/GetAllWithNested`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetProjectResponse>>;
      })
    );
  }
  /**
   * @param showWithArchived undefined
   */
  ProjectGetAllWithNested(showWithArchived?: boolean): __Observable<Array<GetProjectResponse>> {
    return this.ProjectGetAllWithNestedResponse(showWithArchived).pipe(
      __map(_r => _r.body as Array<GetProjectResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  ProjectGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetProjectResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Project/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetProjectResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  ProjectGetById(Id?: string): __Observable<GetProjectResponse> {
    return this.ProjectGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetProjectResponse)
    );
  }

  /**
   * @param Id undefined
   */
  ProjectGetByIdWithNestedResponse(Id?: string): __Observable<__StrictHttpResponse<GetProjectResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Project/GetByIdWithNested`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetProjectResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  ProjectGetByIdWithNested(Id?: string): __Observable<GetProjectResponse> {
    return this.ProjectGetByIdWithNestedResponse(Id).pipe(
      __map(_r => _r.body as GetProjectResponse)
    );
  }

  /**
   * @param request undefined
   */
  ProjectGetAllForProjectTableResponse(request: PaginRequest): __Observable<__StrictHttpResponse<GetProjectsPaginResponseOfGetProjectForTableResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Project/GetAllForProjectTable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetProjectsPaginResponseOfGetProjectForTableResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProjectGetAllForProjectTable(request: PaginRequest): __Observable<GetProjectsPaginResponseOfGetProjectForTableResponse> {
    return this.ProjectGetAllForProjectTableResponse(request).pipe(
      __map(_r => _r.body as GetProjectsPaginResponseOfGetProjectForTableResponse)
    );
  }

  /**
   * @param params The `ProjectService.ProjectGetAllForProcessTableParams` containing the following parameters:
   *
   * - `stageManagerId`:
   *
   * - `companyId`:
   */
  ProjectGetAllForProcessTableResponse(params: ProjectService.ProjectGetAllForProcessTableParams): __Observable<__StrictHttpResponse<Array<GetStageForTableResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.stageManagerId != null) __params = __params.set('stageManagerId', params.stageManagerId.toString());
    if (params.companyId != null) __params = __params.set('companyId', params.companyId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Project/GetAllForProcessTable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetStageForTableResponse>>;
      })
    );
  }
  /**
   * @param params The `ProjectService.ProjectGetAllForProcessTableParams` containing the following parameters:
   *
   * - `stageManagerId`:
   *
   * - `companyId`:
   */
  ProjectGetAllForProcessTable(params: ProjectService.ProjectGetAllForProcessTableParams): __Observable<Array<GetStageForTableResponse>> {
    return this.ProjectGetAllForProcessTableResponse(params).pipe(
      __map(_r => _r.body as Array<GetStageForTableResponse>)
    );
  }

  /**
   * @param request undefined
   */
  ProjectCreateResponse(request: CreateProjectRequest): __Observable<__StrictHttpResponse<CreateProjectResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Project/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CreateProjectResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProjectCreate(request: CreateProjectRequest): __Observable<CreateProjectResponse> {
    return this.ProjectCreateResponse(request).pipe(
      __map(_r => _r.body as CreateProjectResponse)
    );
  }

  /**
   * @param request undefined
   */
  ProjectCreateRangeResponse(request: Array<CreateProjectRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Project/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProjectCreateRange(request: Array<CreateProjectRequest>): __Observable<Blob> {
    return this.ProjectCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ProjectUpdateResponse(request: UpdateProjectRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/Project/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProjectUpdate(request: UpdateProjectRequest): __Observable<Blob> {
    return this.ProjectUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `ProjectService.ProjectDeleteParams` containing the following parameters:
   *
   * - `isPermanent`:
   *
   * - `id`:
   */
  ProjectDeleteResponse(params: ProjectService.ProjectDeleteParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.isPermanent != null) __params = __params.set('isPermanent', params.isPermanent.toString());
    if (params.id != null) __params = __params.set('id', params.id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/Project/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `ProjectService.ProjectDeleteParams` containing the following parameters:
   *
   * - `isPermanent`:
   *
   * - `id`:
   */
  ProjectDelete(params: ProjectService.ProjectDeleteParams): __Observable<Blob> {
    return this.ProjectDeleteResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  ProjectDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/Project/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  ProjectDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.ProjectDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ProjectService {

  /**
   * Parameters for ProjectGetAllForProcessTable
   */
  export interface ProjectGetAllForProcessTableParams {
    stageManagerId?: null | string;
    companyId?: null | string;
  }

  /**
   * Parameters for ProjectDelete
   */
  export interface ProjectDeleteParams {
    isPermanent?: boolean;
    id?: string;
  }
}

export { ProjectService }
